/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
*/
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { setDrawerButton } from "./setDrawerButton";
import { setDataCounter } from "./setDataCounter";
import { setTabSelecter } from "./setTabSelecter";
import { setSwiper } from "./setSwiper";
import { setMouseStalker } from "./setMouseStalker";
import { setScrollTrigger } from "./setScrollTrigger";


function addModule() {
  gsap.registerPlugin(ScrollTrigger);
  let mm = gsap.matchMedia();

  const html = document.documentElement;
  const header = document.querySelector('.header');
  const footer = document.querySelector('.footer');
  const toTopBtn = document.getElementById('toTopBtn');

  /**
   * @name setScrollPaddingTop
   * @description アンカーリンク先に”scroll-padding-top”を設定する
   * @param {Number} headerHeight ヘッダーの高さ
   */
  function setScrollPaddingTop() {
    const init = () => {
      let headerHeight = header.clientHeight;
      html.style.scrollPaddingTop = `${headerHeight}px`;
    }
    init();
    window.addEventListener("resize", init);
  }

  /**
   * @name scrollFixHeader
   * @description 画面上部からのスクロール量を取得し、ヘッダーが画面上部に到達後ロゴを変形させる
   */
  const scrollFixHeader = () => {
    let headerTop = header.getBoundingClientRect().top + window.pageYOffset + 1;
    const init = () => {
      let scrollTop = window.pageYOffset;
      header.querySelector('.logo').dataset.state = scrollTop >= headerTop ? "transform" : "";
      toTopBtn.dataset.state = scrollTop >= headerTop ? "show" : "";
    }
    window.addEventListener('scroll', init);
    window.addEventListener('DOMContentLoaded', init);
  }

  /**
   * @name getViewAreaHeight
   * @description ビューエリアの高さを取得し、スクロール時にビューエリアの高さを変更する
   */
  const getViewAreaHeight = () => {
    const container = document.querySelector('.tab__container');
    if (!container) return;
    const viewArea = document.querySelectorAll('.tab__block .text');
    const viewAreaToggleButton = document.querySelector('.view-area__toggle-button');
    const posEl = document.querySelector('.js-tab-selecter');
    let pos = 0;

    viewAreaToggleButton.addEventListener('click', () => {
      if (container.classList.contains('isView')) {
        container.classList.remove('isView');
        window.scrollTo({ top: pos, behavior: "smooth", });
      } else {
        container.classList.add('isView');
      }
    });

    const init = () => {
      pos = posEl.getBoundingClientRect().top + window.pageYOffset - header.getBoundingClientRect().height;
      viewArea.forEach((el) => {
        const viewAreaHeight = el.getBoundingClientRect().height;
        el.parentElement.style.setProperty('--view-area-height', `${viewAreaHeight}px`);
      });
    }

    window.addEventListener('DOMContentLoaded', init);
    window.addEventListener('resize', init);
  }

  /**
   * @name loadSmoothScrollTo
   * @description ページ読み込み時にスムーススクロールを実行する
   */
  const loadSmoothScrollTo = () => {
    window.addEventListener('load', () => {
      let hash = location.hash;
      let headerHeight = document.querySelector('header').offsetHeight;
      if (hash) {
        let targetId = document.getElementById(hash.replace('#', ''));
        let targetOffsetTop = window.pageYOffset + targetId.getBoundingClientRect().top - headerHeight;
        setTimeout(() => {
          window.scrollTo({
            top: targetOffsetTop,
            behavior: 'smooth'
          });
        }, 1);
      }
    })
  };

  /**
   * @name scrollToTopBtn
   * @description トップへ戻るボタンを押下時にページトップへスクロールする
   */
  function scrollToTopBtn() {
    toTopBtn ? toTopBtn.addEventListener('click', scrollToTop) : null;

    function scrollToTop() {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  /**
   * @name scrollFlagFooter
   * @description スクロール時にfooterから指定した距離までスクロールしたらtrueを返す
   * @param {Number} documentHeight ドキュメントの高さ
   * @param {Number} windwHeight ウィンドウの高さ
   * @param {Number} footerHeight フッターの高さ
   */
  const scrollFlagFooter = () => {
    let documentHeight = document.body.clientHeight;
    let windwHeight = window.innerHeight;
    let footerHeight = footer.clientHeight;
    return window.pageYOffset > documentHeight - windwHeight - footerHeight + 30 ? true : window.pageYOffset < footerHeight ? false : null;
  }

  /**
   * @name transform
   * @description 呼び出した関数を実行する
   */
  const transform = () => {
    scrollFlagFooter() ? html.classList.add('--totop-fixed') : html.classList.remove('--totop-fixed');
  }

  window.addEventListener("scroll", transform);


  setScrollPaddingTop();
  scrollFixHeader();
  getViewAreaHeight();
  loadSmoothScrollTo();
  scrollToTopBtn();
}

/**
 * Do modules.
 */
export function modules() {
  setDrawerButton();
  setDataCounter();
  setTabSelecter();
  setSwiper();
  setMouseStalker();
  setScrollTrigger();
  addModule();
}